import styled, { css } from 'styled-components/macro'
import media from 'styled-media-query'

export const Wrapper = styled.div`
  width: 100%;
  height: calc(100vh - 64px);
  display: flex;
  flex-direction: column;
`

export const Content = styled.main`
  height: 100%;
  ${({ theme }) => css`
    background-color: ${theme.colors.white};
  `}
  display: flex;
  grid-gap: 24px 26px;
  flex-flow: row wrap;
  padding: 24px 32px 24px 32px;

  ${media.lessThan('large')`
    grid-gap: 30px;
  `}

  ${media.greaterThan('huge')`
    justify-content: center;
    padding: 24px 48px 24px 48px;
  `}

  @media (min-width: 768px) and (max-width: 1023px) {
    grid-gap: 24px;
    justify-content: center;
  }

  @media (max-width: 767px) {
    padding: 24px 0 24px 40px;
    grid-gap: 24px 0;
  }
`

export const Cabecalho = styled.div`
  display: grid;
  padding: 32px;
  flex-direction: column;
  grid-template-rows: 1fr 1fr;
  row-gap: 5px;

  ${({ theme }) => css`
    border: 1px solid ${theme.colors.lightGray};
  `}

  ${media.greaterThan('huge')`
    padding: 32px 145px 32px 145px;
  `}

  @media (min-width: 768px) and (max-width: 1023px) {
    padding: 40px;
  }

  @media (max-width: 767px) {
    padding: 0 0 16px 40px;
    row-gap: 0;
  }
`

export const CabecalhoRowUm = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);

  @media (max-width: 767px) {
    grid-template-columns: 1fr;
  }
`

export const DivFlex = styled.div`
  display: inline-flex;
  align-items: center;
  grid-gap: 8px;
`
export const DivRight = styled.div`
  display: none;

  ${media.greaterThan('medium')`
    display: grid;
    justify-items: end;
  `}
`
export const CabecalhoRowDois = styled.div`
  display: inline-flex;
  align-items: center;
  grid-gap: 15px;

  @media (max-width: 767px) {
    flex-direction: column;
    align-items: flex-start;
    grid-gap: 8px;
  }
`
